import React from "react";
import { Skeleton, Tbody, Td, Tr } from "@chakra-ui/react";
import { TableBodyProps } from "@chakra-ui/table/dist/types/table";

interface IProps extends TableBodyProps {
  rowsNum: number;
  colNum: number;
  rowHeight?: string;
}

const SkeletonTableBody = ({
  colNum,
  rowsNum,
  rowHeight = "35px",
  ...restProps
}: IProps) => {
  return (
    <Tbody {...restProps}>
      {Array.from(Array(rowsNum).keys()).map((rowKey) => {
        return (
          <Tr key={rowKey}>
            {Array.from(Array(colNum).keys()).map((colKey) => {
              return (
                <Td key={`${rowsNum}-${colKey}`}>
                  <Skeleton h={rowHeight} isLoaded={false} />
                </Td>
              );
            })}
          </Tr>
        );
      })}
    </Tbody>
  );
};

export { SkeletonTableBody };
